import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { MOCK_FAQS } from '../../mock';
import { Link } from 'react-router-dom';

const FAQPage: React.FC = () => {
  const [active, setActive] = useState<string | null>(null);
  const [filter, setFilter] = useState('All');

  const categories = ['All', ...Array.from(new Set(MOCK_FAQS.map(f => f.category)))];
  const filtered = MOCK_FAQS.filter(f => filter === 'All' || f.category === filter);

  return (
    <div>
      <div className="page-header" style={{ paddingTop: '7rem' }}>
        <h1 style={{ color: 'white', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 800, marginBottom: '1rem' }}>Frequently Asked Questions</h1>
        <p style={{ color: '#94a3b8', maxWidth: '480px', margin: '0 auto' }}>Find answers to the most common questions about our services, pricing, and process.</p>
      </div>

      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container-xl" style={{ maxWidth: '760px' }}>
          <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', justifyContent: 'center', marginBottom: '3rem' }}>
            {categories.map(c => (
              <button key={c} onClick={() => setFilter(c)} style={{
                padding: '0.5rem 1.25rem', borderRadius: '9999px', fontSize: '0.85rem', fontWeight: 500, border: 'none', cursor: 'pointer', transition: 'all 0.2s',
                background: filter === c ? '#f97316' : 'var(--bg-secondary)', color: filter === c ? 'white' : 'var(--text-secondary)',
              }}>
                {c}
              </button>
            ))}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {filtered.map(faq => (
              <div key={faq.id} className="card" style={{ padding: 0, overflow: 'hidden' }}>
                <button onClick={() => setActive(active === faq.id ? null : faq.id)} style={{
                  width: '100%', padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  background: 'none', border: 'none', cursor: 'pointer', textAlign: 'left', gap: '1rem',
                }}>
                  <span style={{ fontWeight: 600, fontSize: '0.95rem', color: 'var(--text-primary)' }}>{faq.question}</span>
                  {active === faq.id ? <ChevronUp size={18} color="#f97316" style={{ flexShrink: 0 }} /> : <ChevronDown size={18} style={{ color: 'var(--text-muted)', flexShrink: 0 }} />}
                </button>
                {active === faq.id && (
                  <div style={{ padding: '0 1.5rem 1.25rem', borderTop: '1px solid var(--border-color)' }}>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7, margin: '1rem 0 0', fontSize: '0.9rem' }}>{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="card" style={{ marginTop: '3rem', textAlign: 'center' }}>
            <h3 style={{ fontWeight: 700, color: 'var(--text-primary)', marginBottom: '0.5rem' }}>Still have questions?</h3>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '0.9rem' }}>Our team is happy to help — call, email, or submit a quote request.</p>
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to="/contact" className="btn-primary">Contact Us</Link>
              <Link to="/get-quote" className="btn-secondary">Get Free Quote</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FAQPage;
